import { render, staticRenderFns } from "./giftsExchange.vue?vue&type=template&id=aa0feade&scoped=true&"
import script from "./giftsExchange.vue?vue&type=script&lang=js&"
export * from "./giftsExchange.vue?vue&type=script&lang=js&"
import style0 from "./giftsExchange.vue?vue&type=style&index=0&id=aa0feade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0feade",
  null
  
)

export default component.exports